export type GateHintKind = 'disk_full' | 'low_network' | 'generic';

type GateHints = Record<GateHintKind, string>;

// Bundled on purpose: the gate renders without i18next, so translations may not be loaded.
const HINTS: Record<string, GateHints> = {
  en: {
    disk_full: 'Free up space on the device, then retry.',
    low_network: 'Weak connection: the update is retrying, keep the app open.',
    generic:
      'The update did not finish. Check your connection, then retry.',
  },
  fr: {
    disk_full: "Libérer de l'espace sur l'appareil, puis réessayer.",
    low_network:
      "Connexion faible : la mise à jour est relancée, l'app doit rester ouverte.",
    generic:
      "La mise à jour n'a pas abouti. Vérifiez la connexion, puis réessayez.",
  },
  it: {
    disk_full: 'Libera spazio sul dispositivo, poi riprova.',
    low_network:
      "Connessione debole: l'aggiornamento sta riprovando, tieni l'app aperta.",
    generic:
      "L'aggiornamento non è andato a buon fine. Controlla la connessione, poi riprova.",
  },
  pt: {
    disk_full: 'Libere espaço no dispositivo e tente novamente.',
    low_network:
      'Conexão fraca: a atualização está tentando novamente, mantenha o app aberto.',
    generic:
      'A atualização não foi concluída. Verifique a conexão e tente novamente.',
  },
  de: {
    disk_full: 'Speicherplatz auf dem Gerät freigeben, dann nochmal versuchen.',
    low_network:
      'Schwache Verbindung: Das Update wird erneut versucht, die App bitte geöffnet lassen.',
    generic:
      'Das Update wurde nicht abgeschlossen. Bitte Verbindung prüfen, dann erneut versuchen.',
  },
  es: {
    disk_full: 'Libera espacio en el dispositivo y inténtalo de nuevo.',
    low_network:
      'Conexión débil: la actualización se está reintentando, mantén la app abierta.',
    generic:
      'La actualización no se completó. Verifica la conexión e inténtalo de nuevo.',
  },
};

export const getGateHint = (kind: GateHintKind, locale: string): string => {
  const primary = locale.split(/[-_]/)[0].toLowerCase();
  return (HINTS[primary] ?? HINTS.en)[kind];
};
